// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"9d267581","378":"6b434c93","527":"54e2c921"}[chunkId] + ".chunk.js";
};